module.exports = __webpack_public_path__ + "static/media/Rectangle 30452.3d237dd0.svg";